<template>
    <div class="customElRow">
        <div v-if="type === 'mobile'" style="height: 65vh;overflow: auto">
            <el-form ref="summaryForm" :model="summaryForm"
                     label-position="left" width="100%" :rules="changeFlag ? null : rules">
                <el-form v-if="type === 'mobile'" ref="summaryForm" :model="summaryForm" label-width="100px"
                         label-position="left" width="100%" :rules="changeFlag ? null : rules">
                    <el-row>
                        <el-form-item label="实习单位" label-position="left">
                            {{ summaryForm.unitName }}
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item label="实习岗位" label-position="left">
                            {{ summaryForm.postName }}
                        </el-form-item>
                    </el-row>
                </el-form>
                <div style="height: 55vh;overflow: auto">
                    <el-row>
                        <el-form-item label="实习内容" prop="content1">
                            <el-input type="textarea" :rows="4" maxlength="500" show-word-limit
                                      v-model="summaryForm.content1" :readonly="changeFlag"/>
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item label="实习体会与收获" prop="content2">
                            <el-input type="textarea" :rows="4" maxlength="500" show-word-limit
                                      v-model="summaryForm.content2" :readonly="changeFlag"/>
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item label="存在不足及努力方向" prop="content3">
                            <el-input type="textarea" :rows="4" maxlength="500" show-word-limit
                                      v-model="summaryForm.content3" :readonly="changeFlag"/>
                        </el-form-item>
                    </el-row>

                    <div>
                        <el-form v-if="type === 'mobile'" ref="summaryForm" :model="summaryForm" label-width="100px"
                                 label-position="top" width="100%">
                            <el-form-item label="实习照片">
                                <el-upload v-if="!summaryFlag && userType === 'stu'"
                                           accept="image/*"
                                           action
                                           :http-request="uploadPhoto"
                                           :before-upload="beforeUpload"
                                           :file-list="fileImgList"
                                           list-type="picture-card"
                                           :on-preview="handlePictureCardPreview"
                                           :on-remove="handleRemove">
                                    <i class="el-icon-plus"></i>
                                </el-upload>

                                <el-upload v-if="summaryFlag || this.userType !== 'stu'" accept=".png,.jpeg,.jpg" action
                                           :http-request="uploadPhoto"
                                           :file-list="fileImgList" list-type="picture-card"
                                           :class="'hidden-Btn'"
                                           :disabled="true"
                                           :on-preview="handlePictureCardPreview"><i
                                    class="el-icon-plus"></i>
                                    <template slot="file" slot-scope="{ file }">
                                        <div class="el-upload-list__item-thumbnail">
                                            <img width="146px" height="146px" :src="file.url" alt=""/>
                                        </div>
                                        <span class="el-upload-list__item-actions">
                                    <span class="el-upload-list__item-preview"
                                          @click="handlePictureCardPreview(file)">
                                        <i class="el-icon-zoom-in"></i>
                                    </span>
                                </span>
                                    </template>
                                </el-upload>
                            </el-form-item>

                        </el-form>

                        <previewer v-if="previewerVisible" ref="previewer" :fileInfo="fileInfo"
                                   :widthPercent="60" :heightNum="650" :topNum="60"
                                   @closePreviewer="previewerVisible = false;">
                        </previewer>
                    </div>
                </div>

                <el-divider v-if="changeFlag">教师评阅</el-divider>
                <div style="width:100%; margin:10px 0 10px 0;">
                    <div v-if="userType === 'tea'" >
                        <el-form ref="scoreForm" :model="summaryForm" label-width="150px"
                                 label-position="top">
                            <el-form-item label="点评内容" prop="evaluate"
                                          :rules="[{required: true, message: ' '}]">
                                <el-input type="textarea" :rows="3" maxlength="500" show-word-limit
                                          v-model="summaryForm.evaluate"/>
                            </el-form-item>

                            <el-form-item v-if="userType === 'tea'" label="点评成绩" prop="score"
                                          :rules="[{required: true, message: ' '}]">
                                <el-select v-model="summaryForm.score" filterable placeholder="请选择" style="width:100%;">
                                    <el-option v-for="item in scoreCombo" :key="item.comboValue" :label="item.comboName"
                                               :value="item.comboValue">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>
                    </div>

                    <div v-else>
                        <el-form ref="scoreForm" :model="summaryForm" label-width="150px" label-position="top">
                            <el-form-item v-if="userType !== 'tea' && changeFlag" label="点评内容">
                                <el-input type="textarea" :rows="3" maxlength="500" show-word-limit
                                          v-model="summaryForm.evaluate" :readonly="true"/>
                            </el-form-item>
                        </el-form>

                        <el-form ref="scoreForm" :model="summaryForm" label-width="150px" label-position="left">
                            <el-form-item v-if="userType !== 'tea' && changeFlag" label="点评成绩">
                                <span v-if="userType === 'stu'">{{ summaryForm.score }}</span>
                                <span v-if="userType === 'ins'">{{ parseScore(summaryForm.score) }}</span>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </el-form>
        </div>

        <div v-else>
            <el-form ref="summaryForm" :model="summaryForm" label-width="150px" label-position="left" width="100%"
                     :rules="changeFlag ? null : rules">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="姓名">
                            {{ summaryForm.stuName }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="班级">
                            {{ summaryForm.className }}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="实习单位">
                            {{ summaryForm.unitName }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="实习岗位">
                            {{ summaryForm.postName }}
                        </el-form-item>
                    </el-col>
                </el-row>
                <div :style="{'height': height,'overflow': 'auto'}">
                    <el-row>
                        <el-form-item label="实习内容" prop="content1">
                            <el-input type="textarea" :rows="4" maxlength="500" show-word-limit
                                      v-model="summaryForm.content1" :readonly="changeFlag"/>
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item label="实习体会与收获" prop="content2">
                            <el-input type="textarea" :rows="4" maxlength="500" show-word-limit
                                      v-model="summaryForm.content2" :readonly="changeFlag"/>
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item label="存在不足及努力方向" prop="content3">
                            <el-input type="textarea" :rows="4" maxlength="500" show-word-limit
                                      v-model="summaryForm.content3" :readonly="changeFlag"/>
                        </el-form-item>
                    </el-row>

                    <div>
                        <el-form-item label="实习照片">
                            <el-upload v-if="!summaryFlag && userType === 'stu'"
                                       accept=".png,.jpeg,.jpg"
                                       action
                                       :http-request="uploadPhoto"
                                       :file-list="fileImgList"
                                       list-type="picture-card"
                                       :on-preview="handlePictureCardPreview"
                                       :on-remove="handleRemove">
                                <i class="el-icon-plus"></i>
                            </el-upload>

                            <el-upload v-if="summaryFlag || this.userType !== 'stu'" accept=".png,.jpeg,.jpg" action
                                       :http-request="uploadPhoto"
                                       :file-list="fileImgList" list-type="picture-card"
                                       :class="'hidden-Btn'"
                                       :disabled="true"
                                       :on-preview="handlePictureCardPreview"><i
                                class="el-icon-plus"></i>
                                <template slot="file" slot-scope="{ file }">
                                    <div class="el-upload-list__item-thumbnail">
                                        <img width="146px" height="146px" :src="file.url" alt=""/>
                                    </div>
                                    <span class="el-upload-list__item-actions">
                                    <span class="el-upload-list__item-preview"
                                          @click="handlePictureCardPreview(file)">
                                        <i class="el-icon-zoom-in"></i>
                                    </span>
                                </span>
                                </template>
                            </el-upload>
                        </el-form-item>

                        <previewer v-if="previewerVisible" ref="previewer" :fileInfo="fileInfo"
                                   :widthPercent="60" :heightNum="650" :topNum="60"
                                   @closePreviewer="previewerVisible = false;">
                        </previewer>
                    </div>
                </div>

                <el-divider v-if="changeFlag">教师评阅</el-divider>
                <div style="width:100%; margin:10px 0 10px 0;">
                    <el-form ref="scoreForm" :model="summaryForm" label-width="150px" label-position="left">
                        <el-form-item v-if="userType === 'tea'" label="点评内容" prop="evaluate"
                                      :rules="[{required: true, message: ' '}]">
                            <el-input type="textarea" :rows="3" maxlength="500" show-word-limit
                                      v-model="summaryForm.evaluate"/>
                        </el-form-item>
                        <el-form-item v-if="userType === 'tea'" label="点评成绩" prop="score"
                                      :rules="[{required: true, message: ' '}]">
                            <el-select v-model="summaryForm.score" filterable placeholder="请选择" style="width:100%;">
                                <el-option v-for="item in scoreCombo" :key="item.comboValue" :label="item.comboName"
                                           :value="item.comboValue">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item v-if="userType !== 'tea' && changeFlag" label="点评内容">
                            <el-input type="textarea" :rows="3" maxlength="500" show-word-limit
                                      v-model="summaryForm.evaluate" :readonly="true"/>
                        </el-form-item>
                        <el-form-item v-if="userType !== 'tea' && changeFlag" label="点评成绩">
                            <span v-if="userType === 'stu'">{{ summaryForm.score }}</span>
                            <span v-if="userType === 'ins'">{{ parseScore(summaryForm.score) }}</span>
                        </el-form-item>
                    </el-form>
                </div>
            </el-form>
        </div>

        <div style="width:100%; text-align:center;margin-top: 5px;">
            <el-button v-if="!summaryFlag && userType === 'stu'" type="primary" @click="summarySave">保 存</el-button>
            <el-button v-if="!summaryFlag && userType === 'stu'" type="warning" @click="summarySubmit">提 交</el-button>
            <el-button v-if="userType === 'tea'" type="primary" @click="saveScore">保 存</el-button>
            <el-button @click="callback">关 闭</el-button>
        </div>
        <br v-if="type!=='mobile'">
    </div>
</template>

<script>
import {confirmMsg, showNotify} from "../../utils/message";
import {globalConfig} from "../../../static/config";
import previewer from 'views/file/previewer.vue';

export default {
    components: {
        previewer,
    },
    props: ['summaryForm', 'summaryFlag', 'userCode', 'userType', 'scoreCombo', 'type', 'dialogWidth'],
    data() {
        return {
            previewerVisible:false,
            fileInfo: {
                name: null,
                type: null,
                url: null,
            },
            photoTitle: '',
            height: '400px',
            fileImgList: [],
            photoDialogVisible: false,
            dialogImageUrl: '',
            changeFlag: true,
            rules: {
                content1: [{
                    required: true,
                    validator: (rule, value, callback) => {
                        if (value.length < 100) {
                            callback(new Error("不能少于一百字"));
                        } else
                            callback()
                    },
                    trigger: ["blur", "change"]
                }],
                content2: [{
                    required: true,
                    validator: (rule, value, callback) => {
                        if (value.length < 100) {
                            callback(new Error("不能少于一百字"));
                        } else
                            callback()
                    },
                    trigger: ["blur", "change"]
                }],
                content3: [{
                    required: true,
                    validator: (rule, value, callback) => {
                        if (value.length < 100) {
                            callback(new Error("不能少于一百字"));
                        } else
                            callback()
                    },
                    trigger: ["blur", "change"]
                }],
            },
        }
    },
    mounted() {
        this.loadPhoto()
        if (this.userType === 'stu' && !this.summaryFlag) {
            this.height = '520px'
            this.changeFlag = false;
        } else {
            this.height = '300px'
            this.changeFlag = true;
        }

        this.$nextTick().then(() => {
            this.$refs['summaryForm'].clearValidate();
        });
    },
    methods: {
        beforeUpload(file) {
            var testmsg = (file.name.substring(file.name.lastIndexOf(".") + 1)).toLocaleLowerCase();
            const extension1 = testmsg === "jpg";
            const extension2 = testmsg === "jpeg";
            const extension3 = testmsg === "bmp";
            const extension4 = testmsg === "png";
            if (!extension1 && !extension2 && !extension3 && !extension4) {
                this.$message({
                    message: "仅允许上传 jpg、jpeg、bmp、png 图片文件！当前文件格式为："+testmsg,
                    type: "info",
                    offset: 80,
                });

                return false;
            } else {
                return true;
            }
        },
        //上传照片
        uploadPhoto(param) {
            let formData = new FormData();
            formData.append('file', param.file);
            formData.append('id', this.summaryForm.id)
            formData.append('userCode', this.userCode);
            this.$api.postPracticeManage.summary.uploadPhoto({
                data: formData
            })
                .then((res) => {
                    if (res.data.data.state == 'success') {
                        showNotify('成功', '上传成功', 'success', 1500);
                        res.data.data.photo.url = globalConfig.HOST_PROXY_ADMIN + globalConfig.fileApi + res.data.data.photo.url
                        this.fileImgList.push(res.data.data.photo)
                    } else {
                        showNotify('失败', '上传失败', 'error', 3000);
                        this.loadPhoto()
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        handlePictureCardPreview(file) {
            this.fileInfo.name = file.name;
            this.fileInfo.url = file.url;
            this.fileInfo.type = file.type;
            this.previewerVisible = true;
        },
        handleRemove(file, fileList) {
            this.$api.postPracticeManage.summary.removePhoto({
                data: file.id,
            }).then((res) => {
                if (res.data.data == 'success') {
                    showNotify('成功', '删除成功', 'success', 1500);

                    for (let i = 0; i < this.fileImgList.length; i++) {
                        if (this.fileImgList[i].id === file.id) {
                            this.fileImgList.splice(i, 1);
                            break;
                        }
                    }

                } else {
                    showNotify('失败', '删除失败', 'error', 3000);
                    this.loadPhoto()
                }
            }).catch((err) => {
                showNotify('错误', err, 'error', 3000);
            });
        },
        loadPhoto() {
            this.$api.postPracticeManage.summary.loadPhoto({
                data: this.summaryForm.id
            })
                .then((res) => {
                    this.fileImgList = res.data.data
                    this.fileImgList.forEach(item => {
                        item.url = globalConfig.HOST_PROXY_ADMIN + globalConfig.fileApi + item.url
                    })
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        parseScore(score) {
            for (let i = 0; i < this.scoreCombo.length; i++) {
                if (this.scoreCombo[i].comboValue === score) {
                    return this.scoreCombo[i].comboName
                }
            }
        },
        saveScore() {
            this.$refs.scoreForm.validate((valid) => {
                if (valid) {
                    let form = {
                        'id': this.summaryForm.id,
                        'userCode': this.userCode,
                        'score': this.summaryForm.score,
                        'evaluate': this.summaryForm.evaluate
                    }
                    this.$api.postPracticeManage.weeklyReport.saveScore({
                        data: form
                    }).then((res) => {
                        let state = res.data.data;
                        switch (state) {
                            case 'success':
                                showNotify('成功', '保存成功', 'success', 1500);
                                this.callback();
                                break;
                            default:
                                showNotify('错误', '保存失败', 'error', 3000);
                                break;
                        }
                    }).catch((error) => {
                        showNotify('错误', error, 'error', 3000);
                    });
                } else {
                    return false;
                }
            });
        },
        summarySubmit() {
            confirmMsg('提交后不可修改，是否确定提交？').then(() => {
                this.summaryForm.stuCode = this.userCode
                this.summaryForm.submitState = '1'
                this.summarySaveMod()
            });
        },
        summarySave() {
            this.summaryForm.stuCode = this.userCode
            this.summaryForm.submitState = '0'
            this.summarySaveMod()
        },
        summarySaveMod() {
            this.$refs['summaryForm'].validate((valid) => {
                if (valid) {
                    this.$api.postPracticeManage.summary.summarySave({
                        data: this.summaryForm,
                    }).then((res) => {
                        let state = res.data.data;
                        switch (state) {
                            case 'success':
                                this.completeDialogVisible = false;
                                showNotify('成功', '保存成功', 'success', 1500);
                                this.callback();
                                break;
                            default:
                                showNotify('错误', '保存失败', 'error', 3000);
                                break;
                        }
                    }).catch((error) => {
                        showNotify('错误', error, 'error', 3000);
                    });
                }
            })
        },
        callback() {
            this.$emit("callback");
        },
    }
}
</script>

<style scoped lang="scss">
.hidden-Btn {
    /deep/ .el-upload {
        display: none;
    }
}

.customElRow .el-row {
    padding-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// summary.vue?f57adf26